import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return 'N/A';
  const d = new Date(date);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(date) {
  if (!date) return 'N/A';
  const d = new Date(date);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getStatusColor(status) {
  const colors = {
    valid: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    expired: 'bg-red-100 text-red-700 border-red-200',
    pending: 'bg-amber-100 text-amber-700 border-amber-200',
    failed: 'bg-red-100 text-red-700 border-red-200',
    draft: 'bg-slate-100 text-slate-700 border-slate-200',
    active: 'bg-emerald-100 text-emerald-700 border-emerald-200',
    pending_approval: 'bg-amber-100 text-amber-700 border-amber-200',
    suspended: 'bg-red-100 text-red-700 border-red-200',
  };
  return colors[status] || colors.draft;
}

export function getRecordTypeLabel(type) {
  const labels = {
    car: 'Light Vehicle',
    '3w': '3-Wheeler',
    bus: 'Bus',
    truck: 'Truck',
    trailer: 'Trailer (CNG Tube)',
    cng_storage: 'CNG Storage',
  };
  return labels[type] || type;
}

export function getRecordTypeEmoji(type) {
  const emojis = {
    car: '🚗',
    '3w': '🛺',
    bus: '🚌',
    truck: '🛻',
    trailer: '🚛',
    cng_storage: '🏭',
  };
  return emojis[type] || '📋';
}

export function getInspectionTypeLabel(type) {
  const labels = {
    new: 'New',
    periodic: 'Periodic',
    after_repair: 'After Repair/Accident',
  };
  return labels[type] || type;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
